import { combineReducers } from 'redux';

const orderMasterInitialState = {
  loadStatus: 0,
  loadedAll: false,
  list: null,
  actioning: false,
};

const recordMasterInitialState = {
  loadStatus: 0,
  loadedAll: false,
  list: null,
  actioning: false,
};

const expressCreateInitialState = {
  saveStatus: 0,
  addressId: null,
  input: {
    receiveExpressNo: '',
    receiveCompany: '',
  },
};

const moneyCreateInitialState = {
  saveStatus: 0,
  input: {
    refundMoneyReason: '',
  },
};

const recordCreateInitialState = {
  info: null,
  input: {
    /* 1: 退货; 2: 换货; */
    type: 2,
    num: 1,
    note: '',
    img: [],
    name: '',
    mobile: '',
  },
  loadStatus: 0,
  saveStatus: 0,
};

function orderMasterReducer(state = orderMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_REFUND_ORDER_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_REFUND_ORDER_LIST_COMPLETION': {
      const { error, range } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(order => order.orderId);

      return {
        ...state,
        loadStatus: 2,
        loadedAll: list.length < range.length,
        list: state.list
          ? state.list.slice(0, range.location).concat(list)
          : list,
      };
    }

    case 'CLEAR_LOAD_ORDER_SKU_LIST': {
      return orderMasterInitialState;
    }

    case 'CREATE_REFUND_RECORD_COMPLETION': {
      if (action.error) {
        return state;
      }

      return orderMasterInitialState;
    }

    default:
      return state;
  }
}

function refundDetailReducer(state = {}, action) {
  switch (action.type) {
    case 'CREATE_REFUND_EXPRESS_COMPLETION': {
      const { error, data, recordId } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [recordId]: {
          ...state[recordId],
          ...data,
        },
      };
    }

    case 'LOAD_REFUND_COMPLETION': {
      const { recordId, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [recordId]: data,
      };
    }

    case 'CANCEL_APPLY_REFUND_COMPLETION': {
      if (action.error) {
        return state;
      }

      const refund = action.data;
      const afterSaleId = refund.afterSaleId;
      const refunds = { ...state };

      if (afterSaleId) {
        refunds[afterSaleId] = { ...refunds[afterSaleId], ...refund };
      }

      return refunds;
    }

    default:
      return state;
  }
}

function refundsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_REFUND_COMPLETION': {
      const { recordId, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [recordId]: data,
      };
    }

    case 'CREATE_REFUND_EXPRESS_COMPLETION': {
      const { error, data, recordId } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [recordId]: {
          ...state[recordId],
          ...data,
        },
      };
    }

    case 'LOAD_REFUND_RECORD_LIST_COMPLETION': {
      if (action.error) {
        return state;
      }

      const refunds = action.list.reduce(
        (obj, refund) => {
          const recordId = refund.afterSaleId;

          if (recordId) {
            obj[recordId] = refund;
          }
          return obj;
        },
        { ...state }
      );

      return refunds;
    }

    case 'CANCEL_APPLY_REFUND_COMPLETION': {
      if (action.error) {
        return state;
      }

      const refund = action.data;
      const afterSaleId = refund.afterSaleId;
      const refunds = { ...state };

      if (afterSaleId) {
        refunds[afterSaleId] = { ...refunds[afterSaleId], ...refund };
      }

      return refunds;
    }

    default:
      return state;
  }
}

function recordMasterReducer(state = recordMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_REFUND_RECORD_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_REFUND_RECORD_LIST_COMPLETION': {
      const { error, range } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(refund => refund.afterSaleId);

      return {
        ...state,
        loadStatus: 2,
        loadedAll: list.length < range.length,
        list: state.list
          ? state.list.slice(0, range.location).concat(list)
          : list,
      };
    }

    default:
      return state;
  }
}

function expressCreateReducer(state = expressCreateInitialState, action) {
  switch (action.type) {
    case 'CLEAR_FOR_REFUND_EXPRESS_CREATE': {
      return expressCreateInitialState;
    }

    case 'CHANGE_REFUND_EXPRESS_INFO': {
      return {
        ...state,
        input: {
          ...state.input,
          ...action.info,
        },
      };
    }

    case 'CREATE_REFUND_EXPRESS': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'CREATE_REFUND_EXPRESS_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2,
      };
    }

    case 'PICK_REFUND_ADDRESS': {
      return {
        ...state,
        addressId: action.address.aid || null,
      };
    }

    default:
      return state;
  }
}

function refundActionsReducer(state = {}, action) {
  switch (action.type) {
    case 'CANCEL_APPLY_REFUND': {
      const { afterSaleId } = action;

      return {
        ...state,
        [afterSaleId]: true,
      };
    }

    case 'CANCEL_APPLY_REFUND_COMPLETION': {
      const { afterSaleId } = action;
      let newState = { ...state };

      delete newState[afterSaleId];

      return newState;
    }

    default:
      return state;
  }
}

function recordCreateReducer(state = recordCreateInitialState, action) {
  switch (action.type) {
    case 'CLEAR_FOR_REFUND_RECORD_CREATE': {
      return recordCreateInitialState;
    }

    case 'CHANGE_INPUT_FOR_REFUND_RECORD_CREATE': {
      return {
        ...state,
        input: {
          ...state.input,
          ...action.input,
        },
      };
    }

    case 'LOAD_INFO_FOR_REFUND_RECORD_CREATE': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_INFO_FOR_REFUND_RECORD_CREATE_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        info: data,
        input: {
          ...state.input,
          ...data.relation,
        },
      };
    }

    case 'CREATE_REFUND_RECORD': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'CREATE_REFUND_RECORD_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2,
      };
    }

    default:
      return state;
  }
}

function moneyCreateReducer(state = moneyCreateInitialState, action) {
  switch (action.type) {
    case 'CLEAR_FOR_REFUND_MONEY_CREATE': {
      return moneyCreateInitialState;
    }

    case 'CHANGE_REFUND_MONEY_CREATE_INFO': {
      return {
        ...state,
        input: {
          ...state.input,
          ...action.info,
        },
      };
    }

    case 'CREATE_REFUND_MONEY': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'CREATE_REFUND_MONEY_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2,
      };
    }

    default:
      return state;
  }
}

function refundMoneyReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_REFUND_MONEY_COMPLETION': {
      const { orderId, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [orderId]: data,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  refundDetail: refundDetailReducer,
  refunds: refundsReducer,
  refundActions: refundActionsReducer,
  orderMaster: orderMasterReducer,
  recordMaster: recordMasterReducer,
  recordCreate: recordCreateReducer,
  expressCreate: expressCreateReducer,
  moneyCreate: moneyCreateReducer,
  refundMoney: refundMoneyReducer,
});
